import script from "./ProductPrice.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductPrice.vue?vue&type=script&lang=ts&setup=true"

import "./ProductPrice.vue?vue&type=style&index=0&id=0bd61a52&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd61a52"]])

export default __exports__